// Loader for the generated prompt bundle (source: prompts/<lang>/*.md, built
// by scripts/build-prompts.js). Twin of backend/prompts.py — keep in sync.
import BUNDLE from './prompts.generated.json';

const DEFAULT = 'en';
const norm = (lang) => (BUNDLE.languages[lang] ? lang : DEFAULT);

function entry(name, lang) {
  // A lang unknown to the bundle (e.g. 'de' when only it/en are registered)
  // is itself a fallback, even though norm() collapses it to the same
  // default language that an own-entry lookup would otherwise hit directly.
  // An omitted lang (undefined/null) is NOT unknown — it's the documented
  // default (DEFAULT, 'en') and resolves without a fallback flag.
  const omitted = lang === undefined || lang === null;
  const known = omitted || BUNDLE.languages[lang] !== undefined;
  if (known) {
    const l = omitted ? DEFAULT : lang;
    const own = BUNDLE.prompts[l]?.[name];
    if (own) return { e: own, used: l, fallback: false };
  }
  if (BUNDLE.prompts.en?.[name]) return { e: BUNDLE.prompts.en[name], used: 'en', fallback: true };
  if (BUNDLE.prompts.it?.[name]) return { e: BUNDLE.prompts.it[name], used: 'it', fallback: true };
  throw new Error(`prompt not found: ${name}`);
}

export function render(name, lang, vars = {}) {
  const { e } = entry(name, lang);
  const all = { language_name: BUNDLE.languages[norm(lang)], ...vars };
  return e.body.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => {
    if (all[k] === undefined || all[k] === null) throw new Error(`prompt ${name}: missing var ${k}`);
    return String(all[k]);
  });
}

// render() with template-literal semantics: every var is String()-ed first,
// so undefined/null print as "undefined"/"null" exactly like the inline
// `${x}` interpolations the prompt builders used before (render() itself
// treats them as missing and throws). Twin of pocketflow_agents._render.
export function renderStr(name, lang, vars = {}) {
  return render(name, lang, Object.fromEntries(Object.entries(vars).map(([k, v]) => [k, String(v)])));
}

export function vocab(lang) {
  const l = norm(lang);
  return { ...BUNDLE.vocab.it, ...BUNDLE.vocab.en, ...BUNDLE.vocab[l] };
}

// The resolved language's OWN vocab entry, without the it<en merge — for
// optional keys that must not leak across languages (e.g. EN-only
// negation_markers). Twin of backend/prompts.py's own_vocab.
export function ownVocab(lang) {
  return BUNDLE.vocab[norm(lang)] || {};
}

export function promptMeta(name, lang) {
  const { e, used, fallback } = entry(name, lang);
  return { name, lang: norm(lang), used, version: e.version, hash: e.hash, fallback };
}

export const promptRef = (name, lang) => {
  const m = promptMeta(name, lang);
  return `${name}@${m.version}#${m.hash}/${m.lang}`;
};
